import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { EmptyState, Page, PageHeader } from "../../../components/ui";
import { getCategories } from "../../../store/actions/uploadMediaAction";
import { addGenre, updateCategory } from "../../../services/genres";
import GenreForm, { initialRows } from "./GenreForm";

/**
 * Updates the existing genres (one per content type) and creates the ones
 * newly enabled.
 */
export async function saveGenres(name, rows) {
  for (const row of rows) {
    if (row._id) {
      await updateCategory(
        {
          name,
          type: row.type,
          is_enabled: row.is_enabled,
          url: row.url,
          _id: row._id,
          isImageSelected: row.isImageSelected,
          imageBase64: row.imageBase64,
        },
        row._id
      );
    } else if (row.is_enabled) {
      await addGenre({
        name,
        type: row.type,
        imageBase64: row.imageBase64,
        is_enabled: true,
      });
    }
  }
}

const UpdateCategory = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { categoriesForUpdate } = useSelector(
    (state) => state.uploadMediaReducer
  );
  const genres = categoriesForUpdate || [];

  // The list page fills the store while navigating here: wait a bit for it.
  const [timedOut, setTimedOut] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setTimedOut(true), 5000);
    return () => clearTimeout(timer);
  }, []);

  const handleSubmit = async (name, rows) => {
    try {
      await saveGenres(name, rows);
      toast.success(t("Genre updated successfully!"), {
        progressStyle: { background: "var(--iq-primary)" },
      });
      dispatch(getCategories([]));
      history.push("/dashboard/category-list");
    } catch (error) {
      toast.error(error?.response?.data?.message || t("Something went wrong"));
    }
  };

  return (
    <Page>
      <PageHeader
        title={t("Edit Genre")}
        subtitle={t("Enable the content types this genre applies to")}
      />
      {genres.length > 0 ? (
        <GenreForm
          key={genres.map((g) => g._id).join()}
          initialName={genres[0]?.name || ""}
          rows={initialRows(genres)}
          onSubmit={handleSubmit}
          submitLabel={t("Save")}
        />
      ) : timedOut ? (
        <section className="ui-card">
          <EmptyState icon="ri-price-tag-3-line">{t("No Data Found")}</EmptyState>
        </section>
      ) : (
        <div className="ui-skeleton" style={{ height: 420 }} />
      )}
    </Page>
  );
};

export default UpdateCategory;
